import HttpClient from '../../utils/HttpClient';

const httpClient = HttpClient.createInstance();

// eslint-disable-next-line import/prefer-default-export
export const forgotPassword = email => httpClient.post('/auth/forgot-password', { email });
